let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3zoIf")).then(() => parcelRequire('8FYIq'));